import { Tooltip } from '@mui/material'

const TextEllipsis = ({ children, className, placement = 'top', id, style }) => {
  return (
    <Tooltip arrow title={children || ''} placement={placement} key={`text-ellipsis-${id}`}>
      <div className={`text-nowrap text-ellipsis overflow-hidden ${className}`} style={style}>
        {children}
      </div>
    </Tooltip>
  )
}

export default TextEllipsis
